import { NavigationItemBase } from '../navigation-item-base';

/**
 * A config containing properties for application launcher items
 */
export class ApplicationLauncherItem extends NavigationItemBase {}
